"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ShimmerRenderer_1 = __importDefault(require("./ShimmerRenderer"));
const get_1 = __importDefault(require("lodash-es/get"));
const SharedPropsService_1 = __importDefault(require("../SharedPropsService"));
const context_1 = require("../context");
const PerformActionContext_1 = require("../context/PerformActionContext");
const lodash_es_1 = require("lodash-es");
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const RenderItem = ({ item, isLoading, triggerAction, routeId, heightScreen = 0, widthScreen = 0, }) => {
    const isRouteFocused = (0, native_1.useIsFocused)();
    if (!item)
        return react_1.default.createElement(react_1.default.Fragment, null);
    const { state } = (0, react_1.useContext)(context_1.Context);
    const widgetMapRef = (0, react_1.useRef)(SharedPropsService_1.default.getPropsValue('widgetRegistry'));
    const props = state.routeMap[routeId].template.datastore[item.id];
    const renderItem = (0, react_1.useCallback)((item) => {
        const Widget = (0, get_1.default)(widgetMapRef.current, `${item.type}`, null);
        const nextProps = state.routeMap[routeId].template.datastore[item.id];
        if (routeId !== null) {
            item.props = Object.assign(Object.assign({}, item.props), nextProps);
        }
        if ((0, lodash_es_1.isEmpty)(item.props)) {
            console.warn('[ Render Skipped ] ', item);
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        const widgetProps = {
            renderItem,
            triggerAction,
            metaData: {
                isRouteFocused,
                platform: {
                    OS: react_native_1.Platform.OS,
                    Version: react_native_1.Platform.Version,
                },
                widgetId: item.id,
                routeId,
                /*** @todo: add actual width and height window size */
                width: 0,
                height: 0,
                heightScreen: heightScreen,
                widthScreen: widthScreen - 32,
                /*** @todo: add more meta data */
            },
        };
        const ComponentX = (0, get_1.default)(Widget, 'Component', null);
        if (ComponentX) {
            /*console.info(
                '*** Render ',
                routeId,
                ' Widget type: ',
                item.type,
                ' with id: ',
                item.id,
                ' at position: ',
                item.position ?? POSITION.BODY,
                ' with Props: ',
                item.props,
            );*/
            return (react_1.default.createElement(ComponentX, Object.assign({ key: item.id }, item.props, widgetProps)));
        }
        console.warn('Component not found in WidgetItem', item);
        return react_1.default.createElement(react_1.default.Fragment, null);
    }, [item.props, props]);
    if (isLoading) {
        return react_1.default.createElement(ShimmerRenderer_1.default, Object.assign({}, item));
    }
    return (0, react_1.useMemo)(() => renderItem(item), [item.props, props]);
};
exports.default = (0, PerformActionContext_1.withPerformActionContext)(RenderItem);
//# sourceMappingURL=RenderItem.js.map